import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Form } from 'react-bootstrap';

import styles from './Novo.module.css';
import getUnidades from '../../../../api/getUnidades';
import { institutionSelect } from '../../../../helpers/unidades';
import generatePassword from '../../../../helpers/generatePassword';
import { matriculaMask, phoneMask } from '../../../../helpers/masks';
import criarUsuario from '../../../../api/criarUsuario';
import logoFesaude2 from '../../../../assets/img/fesaude-logo2.png';

const Novo = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState({
    USER: false,
    RESP: false,
    ADMIN: false,
    CONSULTA: false,
    VR: false,
    VESTUARIO: false,
    MONITOR: false,
    OUVIDORIA: false,
    OUVIDORIA_CONSULTA: false,
    CIPA: false,
    CAPS_ADMIN: false,
    CAPS_SUPERVISOR: false,
    CAPS_OPERADOR: false,
    CAPS_CONSULTA: false,
    CAPS_DOCS: false,
    CAPS_DOCS_ESP: false,
    TODOS_CAPS_CONSULTA: false,
    MDI: false,
    MDI_ADMIN: false,
    ERP: false,
    PESQUISA: false,
    INSCRICAO_ADMIN: false,
    REDUCAO_DE_DANOS: false,
    RD_CONSULTA: false,
    DOCS_DAS: false,
    DOCS_DITI: false,
    DOCS_DTEC: false,
    DOCS_DAF: false,
    DOCS_DG: false,
    CECO_ADMIN: false,
    CECO_OPERADOR: false,
    GESTOR: false,
    ATIV_ADMIN: false,
    ATIV_OPERADOR: false,
    ATIV_CONSULTA: false,
    LEITOS: false,
    LEITOS_UAI: false,
    LEITOS_UAA: false,
    LEITOS_CAPS_AD: false,
    TODOS_LEITOS_CONSULTA: false,
    CONSELHO_CURADOR: false,
    TREINAMENTO: false,
    CEC: false,
    SUPRIMENTOS_ADMIN: false,
    SUPRIMENTOS_CONSULTA: false,
    SUPRIMENTOS_OPERADOR: false,
    INSUMOS_ODONTO: false,
    INSUMOS_PMF: false,
    INSUMOS_RAPS: false,
    INSUMOS_SRT: false,
    MEDICAMENTOS: false,
  });

  const [unidades, setUnidades] = useState([]);

  const initialValues = {
    name: '',
    email: '',
    phone: '',
    unit: '',
    admissionDate: '',
    registration: '',
    institution: 'FeSaúde'
  };

  const roleGroups = [
    {
      group: 'USER',
      roles: [
        'USER', 
        'RESP', 
        'ADMIN', 
        'CONSULTA',
      ]
    },
    {
      group: 'DOCS',
      roles: [
        'DOCS_DAS',
        'DOCS_DITI',
        'DOCS_DTEC',
        'DOCS_DAF',
        'DOCS_DG',
      ]
    },
    {
      group: 'GESTÃO',
      subgroups: [
        {
          title: 'OUVIDORIA',
          roles: [
            'OUVIDORIA', 
            'OUVIDORIA_CONSULTA', 
          ]
        },
        {
          title: 'MDI',
          roles: [
            'MDI', 
            'MDI_ADMIN',
          ]
        },
        {
          title: 'AE',
          roles: [
            'ATIV_ADMIN',
            'ATIV_OPERADOR',
            'ATIV_CONSULTA',
          ]
        },
        {
          title: 'OUTROS',
          roles: [
            'PESQUISA',
            'VESTUARIO',
            'CIPA',
            'CONSELHO_CURADOR',
            'INSCRICAO_ADMIN',
            'TREINAMENTO',
            'CEC',
          ]
        },
      ]
    },
    {
      group: 'RAPS',
      subgroups: [
        {
          title: 'CAPS',
          roles: [
            'CAPS_ADMIN',
            'CAPS_SUPERVISOR',
            'CAPS_OPERADOR',
            'CAPS_CONSULTA',
            'CAPS_DOCS',
            'CAPS_DOCS_ESP',
            'TODOS_CAPS_CONSULTA',
          ]
        },
        {
          title: 'RD',
          roles: [
            'REDUCAO_DE_DANOS',
            'RD_CONSULTA',
          ]
        },
        {
          title: 'CECO',
          roles: [
            'CECO_ADMIN',
            'CECO_OPERADOR',
          ]
        },
        {
          title: 'LEITOS',
          roles: [
            'LEITOS',
            'LEITOS_UAI',
            'LEITOS_UAA',
            'LEITOS_CAPS_AD',
            'TODOS_LEITOS_CONSULTA',
          ]
        },
      ]
    },
    {
      group: 'SUPRIMENTOS',
      subgroups: [
        {
          title: 'MENU',
          roles: [
            'SUPRIMENTOS_ADMIN',
            'SUPRIMENTOS_CONSULTA',
            'SUPRIMENTOS_OPERADOR',
          ]
        },
        {
          title: 'REQUISIÇÃO',
          roles: [
            'INSUMOS_ODONTO',
            'INSUMOS_PMF',
            'INSUMOS_RAPS',
            'INSUMOS_SRT',
          ]
        },
        {
          title: 'MEDICAMENTOS',
          roles: [
            'MEDICAMENTOS',
          ]
        }
      ]
    },
    {
      group: 'OUTROS',
      roles: [
        'GESTOR',
        'ERP',
        'VR',
        'MONITOR'
      ]
    }
  ]

  const [values, setValues] = useState(initialValues);

  const setValue = (key, value) => {
    setValues({
      ...values,
      [key]: value
    });
  };

  const handleChange = e => {
    if (e.target.name === 'phone') {
      e.target.value = phoneMask(e.target.value);
    }

    if (e.target.name === 'registration') {
      e.target.value = matriculaMask(e.target.value);
    }

    setValue(e.target.getAttribute('name'), e.target.value);
  };

  const handleCheck = e => {
    let newRoles = roles;
    newRoles[e.target.id] = e.target.checked;

    setRoles(newRoles);
  };

  useEffect(() => {
    const fetchUnidades = async () => {
      const response = await getUnidades('sisged');

      setUnidades(response);
    };

    fetchUnidades();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    setLoading(true);

    const rolesArray = roles => Object.entries(roles).reduce((acc, [key, value]) => {
      if (value) {
        acc.push(key);
      }

      return acc;
    }, []);

    const data = {
      name: values.name,
      email: values.email.toLowerCase(),
      phone: values.phone,
      unit: values.unit,
      institution: values.institution,
      admissionDate: values.admissionDate,
      registration: values.registration,
      roles: rolesArray(roles),
      password: generatePassword(8)
    };

    criarUsuario(data);

    setLoading(false);

    history.push('/admin/usuarios');
  };

  return (
    <div className={styles.container}>
      <div className={styles.form_container}>
        <div className={styles.logo}>
          <div>
            <img src={logoFesaude2} alt="Logo FeSaúde" />
          </div>
          <div>
            <h1 className={styles.title}>Criar Usuário</h1>
          </div>
        </div>
        <Form onSubmit={handleSubmit} noValidate>
          <div className={styles.form}>
            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="institution">
                  <Form.Label>*Instituição:</Form.Label>
                  <Form.Select
                    autoComplete="nope"
                    className="border border-secondary"
                    required
                    name="institution"
                    onChange={handleChange}
                    value={values.institution}
                    disabled
                  >
                    <option value="" disabled>Selecione a Instituição</option>
                    {institutionSelect.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="registration">
                  <Form.Label>*Matrícula:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    required
                    className={styles.input}
                    type="text"
                    name="registration"
                    onChange={handleChange}
                    value={values.registration}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="name">
                  <Form.Label>*Nome:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    className={styles.input}
                    type="nope"
                    required
                    name="name"
                    onChange={handleChange}
                    value={values.name}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="email">
                  <Form.Label>*e-mail:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    className={styles.input}
                    type="email"
                    required
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="phone">
                  <Form.Label>*Telefone:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    className={styles.input}
                    type="text"
                    required
                    name="phone"
                    onChange={handleChange}
                    value={values.phone}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="admissionDate">
                  <Form.Label>*Data de admissão:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    required
                    className={styles.input}
                    type="date"
                    name="admissionDate"
                    onChange={handleChange}
                    value={values.admissionDate}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="unit">
                  <Form.Label>*Lotação:</Form.Label>
                  <Form.Select
                    autoComplete="nope"
                    className="border border-secondary"
                    required
                    name="unit"
                    onChange={handleChange}
                    value={values.unit}
                  >
                    <option value="" disabled>Selecione a lotação</option>
                    {unidades && unidades.map(item => (
                      <option key={item._id} value={item.unidade}>{item.unidade}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
            <div className={styles.input_container}>
              <Form.Label className='mt-4'>*Roles</Form.Label>
                { roleGroups.map(group => (
                  <div className={styles.groupContainer} key={group.group}>
                    <span className={styles.groupTitle}>{group.group}</span>
                    { group.subgroups ? (
                      <div>
                        { group.subgroups.map(subgroup => (
                          <div className={styles.subgroupContainer} key={subgroup.title}>
                            <span className={styles.subgroupTitle}>{subgroup.title}</span>
                            <div className={styles.subgroupChecks}>
                              { subgroup.roles.map(role => (
                                <Form.Check
                                  key={role}
                                  label={role}
                                  name="roles"
                                  type="checkbox"
                                  id={role}
                                  value={role}
                                  onChange={handleCheck}
                                />
                              )) }
                          </div>
                          </div>
                        )) }
                      </div>
                    ) : (
                      <div className={styles.groupChecks}>
                        { group.roles.map(role => (
                          <Form.Check
                            key={role}
                            label={role}
                            name="roles"
                            type="checkbox"
                            id={role}
                            value={role}
                            onChange={handleCheck}
                          />
                        )) }
                      </div>
                    ) }
                  </div>
                ))}
            </div>
          </div>
          <div className={styles.button}>
            {loading && (
              <Button variant="flat" className={styles.btn} disabled type="submit">
                Enviando...
              </Button>
            )}

            {!loading && (
              <Button variant="flat" className={styles.btn} type="submit">
                Enviar
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Novo;
